import { createTelemetryAPI } from '~/utils/telemetry'

export const trafficMirrorReportTelemetry = createTelemetryAPI(({ track }) => ({
  createReport(orgId: string, clusterId: string, params: any) {
    return track('Traffic Mirror Report: Create Report', {
      orgId,
      clusterId,
      params
    })
  },
  viewReport(msg: { orgId: string; clusterId: string; reportId: string }) {
    return track('Traffic Mirror Report: View Report', msg)
  },
  deleteReport(msg: { orgId: string; clusterId: string; reportId: string }) {
    return track('Traffic Mirror Report: Delete Report', msg)
  }
}))
